import { EventBus, Events } from "jiffy-store";
import { readCookie, writePersistentCookie, deleteCookie } from "common/utils/cookie";

const WHOLESALE_PRICING_TOAST_ID = "js-wholesale-pricing-toast";
const TRANSITION_DURATION_MS = 300;
const HIDDEN_STATE = ["opacity-0", "-translate-y-5", "pointer-events-none"];
const VISIBLE_STATE = ["opacity-100", "translate-y-0", "pointer-events-auto"];
const DISMISSED_COOKIE_NAME = "wholesale_pricing_toast_dismissed";
const MOBILE_TOAST_FLOW_REMOVE = ["fixed", "top-25", "right-1", "lg:right-2"];
const MOBILE_TOAST_FLOW_ADD = ["relative", "mx-auto", "mt-2"];

class WholesalePricingToast {
  constructor() {
    this.id = WHOLESALE_PRICING_TOAST_ID;
    this.$toast = document.getElementById(this.id);

    if (this.$toast) {
      this.applyMobileAppFlowPositioning();
    }

    if (this.$toast && WholesalePricingToast.shouldShow()) {
      this.bindEvents();
      this.show();
    } else if (this.$toast && !WholesalePricingToast.shouldShow()) {
      this.hide();
    }
  }

  get $closeBtn() {
    return this.$toast?.querySelector(".js-close-toast");
  }

  static isUserLoggedIn() {
    return Boolean(readCookie("name"));
  }

  static isDismissed() {
    return readCookie(DISMISSED_COOKIE_NAME) === "1";
  }

  static markAsDismissed() {
    writePersistentCookie(DISMISSED_COOKIE_NAME, "1");
  }

  static clearDismissed() {
    deleteCookie(DISMISSED_COOKIE_NAME);
  }

  bindEvents() {
    if (!this.$toast) return;

    this.$closeBtn?.addEventListener("click", this.hide);
  }

  static shouldShow() {
    return WholesalePricingToast.isUserLoggedIn() && !WholesalePricingToast.isDismissed();
  }

  static isMobileApp() {
    return Boolean(window.MOBILE_APP);
  }

  applyMobileAppFlowPositioning() {
    if (!this.$toast) return;
    if (!WholesalePricingToast.isMobileApp()) return;

    this.$toast.style.removeProperty("top");
    this.$toast.classList.remove(...MOBILE_TOAST_FLOW_REMOVE);
    this.$toast.classList.add(...MOBILE_TOAST_FLOW_ADD);
  }

  show() {
    const { $toast } = this;
    if ($toast && WholesalePricingToast.shouldShow()) {
      $toast.classList.remove("hidden");

      $toast.dataset.visible = "true";
      $toast.classList.remove(...HIDDEN_STATE);
      $toast.classList.add(...VISIBLE_STATE);
    }
  }

  hide = () => {
    const { $toast } = this;
    if ($toast) {
      $toast.dataset.visible = "false";
      $toast.classList.remove(...VISIBLE_STATE);
      $toast.classList.add(...HIDDEN_STATE);

      setTimeout(() => {
        if ($toast.dataset.visible === "false") {
          $toast.classList.add("hidden");
        }
      }, TRANSITION_DURATION_MS);
    }

    WholesalePricingToast.markAsDismissed();
    this.dispatchDismissedEvent();
  };

  dispatchDismissedEvent() {
    EventBus.publish(Events.WHOLESALE_PRICING_TOAST_DISMISSED, this, { toast: this });
  }
}

const initWholesalePricingToast = () => {
  if (!WholesalePricingToast.isUserLoggedIn()) {
    WholesalePricingToast.clearDismissed();
  }

  const toast = new WholesalePricingToast();
  return toast;
};

document.addEventListener("DOMContentLoaded", initWholesalePricingToast);

export default WholesalePricingToast;
